import React, { useRef, useState, useEffect }  from 'react';
import Draggable from 'react-draggable';
import styles from './DraggablePopup.module.css';
import CodeInput from '../AlbumEditor/CodeInput';

interface DraggablePopupProps {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
}

const DraggablePopup: React.FC<DraggablePopupProps> = ({ title, onClose, children }) => {

    const onContentChange = (e : any) => {
        console.log(e)
    }

    return (
        <Draggable handle=".dragHandle">
            <div className={`${styles.popup} ${styles.resizable_popup}`}>
                <div className={`${styles.popupHeader} dragHandle`}>
                    <span>{title}</span>
                    <button onClick={onClose} className={styles.closeButton}>X</button>
                </div>
                <div className={`${styles.popupContent} ${styles.scrollable_content}`}>
                    <CodeInput content="<h1>hi there</h1>" onContentChange={onContentChange}/>
                </div>
            </div>
        </Draggable>
    );
}

export default DraggablePopup;
